export default {
	install(Vue, options) {
		Vue.prototype.getPdf = async function (reportName, isDownload = true) {
			if (typeof html2pdf === 'undefined') {
				throw new Error('html2pdf.js library is not loaded');
			}

			const element = document.querySelector('#pdfDom');
			if (!element) {
				throw new Error('Element #pdfDom not found');
			}

			// 等待 Vue DOM 更新
			await new Promise(resolve => setTimeout(resolve, 100));

			// === 1. 克隆 DOM ===
			const clone = element.cloneNode(true);

			// === 2. 处理 textarea（仅当存在时）===
			const textareas = clone.querySelectorAll('textarea');
			if (textareas.length > 0) {
				textareas.forEach(ta => {
					const div = document.createElement('div');
					const style = window.getComputedStyle(ta);
					div.style.cssText = style.cssText;

					// ✅ 显式继承 text-align，避免居中
					// 如果你希望默认左对齐，可以强制设置：
					// div.style.textAlign = style.textAlign || 'left';

					div.style.whiteSpace = 'pre-line';
					div.style.wordWrap = 'break-word';
					div.style.boxSizing = 'border-box';
					div.style.display = 'block';

					div.innerHTML = ta.value.replace(/\n/g, '<br>');
					div.classList.add('pdf-textarea-replacement');

					ta.parentNode.replaceChild(div, ta);
				});
			}

			// === 处理 quill-editor：提取内容并重建为标准 div 容器 ===
			const quillWrappers = clone.querySelectorAll('.quill-editor, .ql-container, [class*="quill"]');
			if (quillWrappers.length > 0) {
				quillWrappers.forEach(quillContainer => {
					// 找到真正的内容区
					const qlEditor = quillContainer.querySelector('.ql-editor') || quillContainer;

					// 创建全新的替换容器
					const replacementDiv = document.createElement('div');

					// 继承基本样式（字体、大小、行高）
					const style = window.getComputedStyle(qlEditor);
					replacementDiv.style.fontFamily = style.fontFamily;
					replacementDiv.style.fontSize = style.fontSize;
					replacementDiv.style.lineHeight = style.lineHeight || '1.6';
					replacementDiv.style.color = style.color;
					replacementDiv.style.minHeight = '80px';
					replacementDiv.style.boxSizing = 'border-box';
					replacementDiv.style.wordWrap = 'break-word';
					// 强制默认左对齐（避免继承居中）
					replacementDiv.style.textAlign = 'left';

					// 清空内容，准备重建
					replacementDiv.innerHTML = '';

					// 遍历 .ql-editor 下的每一行（通常是 <p>, <h1>, <li> 等）
					Array.from(qlEditor.children).forEach(child => {
						const tag = child.tagName.toLowerCase();
						const textContent = child.innerHTML || ''; // 保留粗体等内联标签

						// 创建新元素
						const el = document.createElement(tag);

						// 复制文本内容（含 innerHTML，保留 <strong>, <em> 等）
						el.innerHTML = textContent;

						// 判断对齐方式：检查 class 或 style
						if (child.classList.contains('ql-align-center')) {
							el.style.textAlign = 'center';
						} else if (child.classList.contains('ql-align-right')) {
							el.style.textAlign = 'right';
						} else if (child.classList.contains('ql-align-justify')) {
							el.style.textAlign = 'justify';
						} else {
							// 没有对齐类，默认继承父级（left）或看是否有 style
							const textAlign = child.style.textAlign || '';
							if (textAlign) el.style.textAlign = textAlign;
						}

						// 设置 margin，模拟段落间距
						el.style.margin = '8px 0';
						el.style.padding = '0';

						// 添加到容器
						replacementDiv.appendChild(el);
					});

					// 如果没有内容，加一个空行占位
					if (qlEditor.children.length === 0) {
						const placeholder = document.createElement('div');
						placeholder.style.height = '20px';
						replacementDiv.appendChild(placeholder);
					}

					// 替换原始编辑器
					quillContainer.parentNode.replaceChild(replacementDiv, quillContainer);
				});
			}

			// ===================

			const opt = {
				margin: [10, 15, 10, 15],
				filename: reportName + '.pdf',
				image: { type: 'jpeg', quality: 0.98 },
				html2canvas: {
					scale: 2,
					useCORS: true,
					logging: false
				},
				jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
				pagebreak: {
					mode: ['avoid-all', 'css', 'legacy'],
					before: '.page-break-before',
					after: '.page-break-after',
					avoid: '.page-break-inside-avoid'
				}
			};

			try {
				if (isDownload) {
					await html2pdf().set(opt).from(clone).save();
					return;
				} else {
					const pdfBlob = await html2pdf().set(opt).from(clone).output('blob');
					return pdfBlob;
				}
			} catch (error) {
				throw error;
			}
		};
	}
};
